import { User } from "../shared/types";
import { MultiStringFormCombobox } from "@/components/forms/FormCombobox";

interface ManagerSelectProps {
  managers: User[];
  value: string[];
  onChange: any;
  disabled?: boolean;
}

export default function ManagerSelect(props: ManagerSelectProps) {
  const { managers, value, onChange, disabled } = props;

  const options = managers.map((manager) => manager.id).filter(Boolean) as string[];

  return (
    <MultiStringFormCombobox
      id="checkboxes-tags-demo"
      options={options}
      value={value || []}
      disabled={disabled}
      getOptionLabel={(managerId) =>
        managers.find((manager) => managerId === manager.id)?.email || ""
      }
      onChange={(next) => {
        onChange(
          {
            type: "change",
            preventDefault() {},
            stopPropagation() {},
          },
          next
        );
      }}
    />
  );
}
